import styled from 'styled-components';
import { Button } from '../../atoms';
export const HiddenPriceContainer = styled.div`
  position: relative;

  span {
    filter: blur(3px);
  }
`;
export const ShowPriceButton = styled(Button)`
  visibility: hidden;
  position: absolute;
  bottom: 0;

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${HiddenPriceContainer}:hover & {
    visibility: visible;
  }
`;